module.exports = __webpack_public_path__ + "img/sm-logo.99a7ea0e.png";